module.exports = __webpack_public_path__ + "static/media/Gold.a4955690.svg";